import moduleConfig from './groceryMarket.config';

export default [
  {
    path: moduleConfig.basePath,
    component: () => import('./groceryMarket.module'),

    children: [
      {
        path: 'grocery/:market',
        name: 'groceryMarket',
        component: () => import('./views/groceryMarket.vue'),
      },
      {
        path: 'groceryListing/:data/:market',
        name: 'grocery-listing',
        component: () => import('./views/groceryListing.vue'),
      },
    ],
  },
];
